import Alpine from "alpinejs";

function initAlpineJs() {
    window.Alpine = Alpine
    Alpine.start()
}

initAlpineJs();